import VErrorBackToRefUrl from '@/components/Error/ErrorBackToRefUrl';
import Proxy from '@/proxies/UnbarringProxy';
import { ERROR_FATAL_CODE, ERROR_RETRY_CODE } from '@route-types';

export default (context, data) => {
  data.retryButtonHook = VErrorBackToRefUrl;

  const parseError = async () => {
    if (!context.$store.state.unbarring.refUrl) {
      try {
        const response = await new Proxy().getErrorParameters();
        await context.$store.dispatch('unbarring/set', response);
      } catch (e) {}
    }

    const { retryableErrorCodes, redirectTime, refUrl } = context.$store.state.unbarring;
    data.retryButtonBindings.refUrl = refUrl;

    if (context.error) {
      // const errorStatus = context.error?.status;
      const code = context.error?.data?.code || 'BACKEND_ERROR';
      const errorCodeType = context.error?.data?.codeType;
      // const errorMessage = context.error?.data?.message;
      const errorLevel = context.error?.data?.args?.TextID;

      let name = errorCodeType === 'RETRY' ? ERROR_RETRY_CODE : ERROR_FATAL_CODE;

      if (code === 'UNBARRING_ERROR') {
        // UNBARRING_ERROR default is "RETRY" but is actually only retryable if in list...
        name = Array.isArray(retryableErrorCodes) && retryableErrorCodes.includes(errorLevel) ? ERROR_RETRY_CODE : ERROR_FATAL_CODE;
      }

      if (errorLevel) {
        context.$router.replace({
          name,
          params: { code, errorLevel },
        });
      } else {
        context.$router.replace({
          name,
          params: { code },
        });
      }
      return;
    }

    if (context.$route.name === ERROR_FATAL_CODE && redirectTime && refUrl) {
      data.retryButtonBindings.redirectTime = redirectTime;
    }
  };

  return {
    parseError,
  };
};
